import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import "./index.css";

// redux imports
import {
  ownerListViewAllAcc,
  getOwnerAccBalance,
  setshowsuccestoast,
  setToggle,
  removeOwnerAccTags,
  addOwnerAccTags,
  removeNewLabelOwner,
  addNewLabelOwner,
  resetToggle,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { toast_position } from "../../../../redux/features/Settings/Authorization";

// components imports
import OwnerViewAllCard from "../OwnerViewAllCard/index";
import ListView from "../../../../components/Accounts/OwnerAccounts/listView/index";
import RefreshAllLoader from "../../../../components/Accounts/OwnerAccounts/RefreshAllLoader/index";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast/index";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index";
import OwnerAllStatement from "../OwnerAllStatement";
import Loader from "../../../../components/Loader/Index";
import IconRoundButton from "../../../../components/_utils/CommonButtons/IconRoundButton";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import SwitcherTabsWithSplitView from "../../../../components/_utils/CommonButtons/SwitcherTabWithSplitView";
import TopNavComponentWithBalance from "../../../../components/_utils/CommonTopNav/TopNavComponentTotalBalance";
import CommonAssignTagPopup from "../../../../components/_utils/CommonPopups/CommonAssignTagPoppup";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const OwnerAccViewAll = ({
  typepop,
  setOpenOwner,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  txnPayLoad,
  setTxnPayLoad,
  BenEnableNextButton,
  handleButtonClick,
  flow,
  owneraccountNumber,
  setownerAccountNumber,
  owneraccountnumberstate,
  setowneraccountnumberstate,
  multiSelect,
  onClosed,
  setDefaultAccountNumber,
  owneraccountDefaultNumber,
  popType,
  setRefactorAccDetail,
  type,
  setpaymentBox,
  selectedLabelsCreate,
  TypeRTGS,
  currentAccountDetails,
}) => {
  const MAX_SELECT_LIMIT = IntervalConfiguration.intervalTiny;

  const location = useLocation();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const { searchParam, handleClearSearchParam, handleSearchParams } =
    useCustomSearchParams(
      location?.state && location?.state?.approvalStatus
        ? {
            connectbank: location?.state?.approvalStatus,
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          }
        : {
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          },
    );

  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [tagsOptions, setTagsOptions] = useState([]);
  const [connectedBankingData, setConnectedBankingData] = useState([]);
  const [previd, setID] = useState(false);
  const [searchUserText, setSearchUserText] = useState(
    searchParam.get("search") || "",
  );
  const [searchUserTextDebounce, setsearchUserTextDebounce] = useState("");
  const [mainData, setMainData] = useState([]);

  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);

  const [inputData, setInputData] = useState([]);

  const [accData, setAccData] = useState("");
  const [viewStatementOpenPop, setViewstatementOpenPop] = useState(false);
  const [statementId, setStatementId] = useState("");
  const [total_balance_state, setTotal_balance_state] = useState(0);
  const [prev_total_balance_state, setPrev_Total_balance_state] = useState(0);
  const [refreshAllData, setRefreshAllData] = useState([]);
  const [successRefreshId, setSuccessRefreshId] = useState([]);
  const [failedRefreshId, setFailedRefreshId] = useState([]);
  const [refreshType, setRefreshtype] = useState("");
  const [selectAmtType, setSelectAmtType] = useState("Default");
  const [refreshAll, setRefreshAll] = useState(false);
  const [splitView, setSplitView] = useState("");
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [connectedbankingstate, setConnectedbankingstate] = useState(
    typepop === "popup" && flow !== "internalTxn"
      ? "Active"
      : searchParam.get("connectbank") || "",
  );
  const [typeaccountstate, settypeaccountstate] = useState(
    searchParam.get("acctype") || "",
  );
  const [bankstate, setbankstate] = useState(searchParam.get("bank") || "");
  const [accountbalancestate, setaccountbalancestate] = useState(
    searchParam.get("sort") || "",
  );
  const [accountnumberstate, setaccountnumberstate] = useState(
    searchParam.get("accno") || "",
  );
  const [ifscstate, setifscstate] = useState(searchParam.get("ifsc") || "");
  const [panstate, setpanstate] = useState(searchParam.get("pan") || "");
  const [ownerTagState, setOwnerTagState] = useState(
    searchParam.get("tag")?.split(",") || [],
  );
  const [isAssignTagsClicked, setIsAssignTagsClicked] = useState(false);
  const [assignTagsAccounts, setAssignTagsAccounts] = useState([]);
  const [newSelectedTags, setNewSelectedTags] = useState([]);
  const [AllTags, setAllTags] = useState([]);
  const [isTagsPopupOpen, setIsTagsPopupOpen] = useState(false);
  const [selectedAssignedAccountID, setSelectedAssignedAccountID] =
    useState("");
  const [selectedAccount, setSelectedAccount] = useState(
    "All selected accounts",
  );
  const [allData, setAllData] = useState([]);
  const [favouritesFilter, setFavouritesFilter] = useState(
    location?.state?.filter
      ? location?.state?.filter
      : searchParam.get("favourite") || "",
  );
  const [allSelected, setAllSelected] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const indicatorRef = useRef(null);
  const balanceSelectorRef = useRef(null);

  const AccountTypeMapper = {
    "Current account": "Current Account",
    "Overdraft account": "Overdraft Account",
    "Cash credit account": "CACC",
    "Fixed deposit account": "Fixed Deposit Account",
  };

  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labelAccounts, setLabelAccounts] = useState([]);
  const [labelsFilter, setFilterLabels] = useState(
    searchParam.get("label")?.split(",") || [],
  );
  const [labels, setLabels] = useState([]);

  const labelActionDispatchedRef = useRef(false);
  const tagActionDispatchedRef = useRef(false);

  const scrollContainerRef = useRef(null);

  const handleScrollToTop = () => {
    const scrollTarget = scrollContainerRef.current || window;
    scrollTarget.scrollTo({
      top: GlobalConfiguration.lengthCheckZero,
      behavior: "smooth",
    });
  };

  const services = useSelector((state) => state.refreshToken.services);

  const {
    ownerAccBalanceLoading,
    ownerAccBalanceError,
    toggle,
    showSuccessToast,
  } = useSelector((state) => state.ownerAllVerification);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filterRef = useRef(null);
  const setScrollableContainerRef = (node) => {
    scrollContainerRef.current = node;
    filterRef.current = node;
  };

  const handleMount = async () => {};

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < ScreenSizeConfiguration.tabviewEnd;
      if (isMobile) {
        setSplitView(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(enableSwitcher());
    handleMount();
    return () => {
      dispatch(disableSwitcher());
      dispatch(resetToggle());
    };
  }, [markerData]);

  useEffect(() => {
    if (isAssignTagsClicked || isLabelClicked) dispatch(disableSwitcher());
    else dispatch(enableSwitcher());
  }, [isAssignTagsClicked, isLabelClicked]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("AvailableLabelsOwner");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    markerData,
    currentPage,
    toggle,
    searchUserText,
    pageSize,
    favouritesFilter,
    accountnumberstate,
    panstate,
    ifscstate,
    connectedbankingstate,
    accountbalancestate,
    typeaccountstate,
    ownerTagState,
    labelsFilter,
    bankstate,
  ]);

  let availableTags = mainData?.summary?.available_tags || tagsOptions || [];

  const selectedTagsCards = accumulatedData?.filter((account) =>
    assignTagsAccounts.includes(account.id),
  );

  const fetchData = async () => {
    setFailedRefreshId([]);
    setSuccessRefreshId([]);
    setRefreshtype(false);

    try {
      setLoading(true);

      let response = await dispatch(
        ownerListViewAllAcc({
          page_no: currentPage,
          page_size: pageSize,
          search_string: searchUserText?.length ? searchUserText : undefined,
          type_of_account: typeaccountstate?.length
            ? AccountTypeMapper[typeaccountstate]
            : undefined,

          bank_name: bankstate?.length ? bankstate : undefined,
          connected_banking:
            typepop === "popup" && flow !== "internalTxn"
              ? "Y"
              : connectedbankingstate?.length
                ? connectedbankingstate === "Active"
                  ? "Y"
                  : "N"
                : undefined,
          bank_account_no: accountnumberstate?.length
            ? accountnumberstate
            : undefined,
          ifsc: ifscstate?.length ? ifscstate : undefined,
          pan: panstate?.length ? panstate : undefined,
          sort_by_balance: accountbalancestate?.length
            ? accountbalancestate
            : undefined,
          tag: favouritesFilter
            ? ""
            : ownerTagState?.length && !favouritesFilter
              ? ownerTagState
              : undefined,
          labels: favouritesFilter
            ? ""
            : labelsFilter?.length && !favouritesFilter
              ? labelsFilter
              : undefined,
          favourite:
            favouritesFilter === "Show only favourite"
              ? "Y"
              : favouritesFilter === "Hide favourite"
                ? "N"
                : undefined,
        }),
      );

      if (
        !(
          favouritesFilter ||
          searchUserText?.length ||
          connectedbankingstate?.length ||
          accountbalancestate?.length ||
          ownerTagState?.length ||
          labelsFilter?.length ||
          typeaccountstate?.length ||
          bankstate?.length ||
          panstate?.length ||
          accountnumberstate?.length ||
          ifscstate?.length
        ) ||
        (location?.state &&
          bankOptions?.length === GlobalConfiguration.lengthCheckZero) ||
        (location?.state && !typeaccountstate?.length)
      ) {
        setBankOptions(response?.payload?.summary?.available_banks || []);
        setTagsOptions(response?.payload?.summary?.available_tags || []);
      } else {
        if (sessionStorage?.getItem("AvailableTags")) {
          let val = sessionStorage?.getItem("AvailableTags");
          setTagsOptions(JSON.parse(val) || []);
        }
      }
      const newData = response?.payload?.owner_accounts || [];
      setMainData(response?.payload);
      setTotal_balance_state(Number(response?.payload?.total_balance || 0));
      setAccumulatedData(newData);
      setAllData((prev) => {
        return [
          ...new Map(
            [...prev, ...newData].map((item) => [item["id"], item]),
          ).values(),
        ];
      });
      setConnectedBankingData(
        newData.filter((account) => {
          return account.connected_banking === "Y";
        }),
      );
      setLoading(false);

      if (
        response?.payload?.response?.data?.errors?.user_unauthorized?.length
      ) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "VAccount" },
        });
      }
    } catch (error) {
      setAccumulatedData([]);
      setMainData([]);
      setLoading(false);
    }
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setCurrentPage(1);
    setSelectedValue(value);
    setPageSize(value);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (ownerAccBalanceLoading) {
      UniversalRefreshToast();
    }
    if (!ownerAccBalanceLoading && !ownerAccBalanceError) {
      setTimeout(() => {
        toast.dismiss();

        if (showSuccessToast) {
          setTimeout(() => {
            CommonToast({
              text: "Balance refreshed successfully.",
              icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
            dispatch(setshowsuccestoast());
          }, 250);
        }
      }, 500);
    }
  }, [ownerAccBalanceLoading]);

  const handleAddTags = async (item) => {
    if (tagActionDispatchedRef) {
      tagActionDispatchedRef.current = true;
    }

    try {
      let tagsToAdd;
      if (typeof item === "string") {
        tagsToAdd = [item];
      } else if (item?.type === "newAss" && Array.isArray(item?.data1)) {
        tagsToAdd = item.data1;
      } else {
        throw new Error("Invalid item format");
      }
      const response = await dispatch(
        addOwnerAccTags({
          owner_id:
            selectedAssignedAccountID !== ""
              ? [selectedAssignedAccountID]
              : [...assignTagsAccounts],
          tags: tagsToAdd,
        }),
      );

      if (response?.payload?.status === true) {
        let val = allData.map((itm) => {
          if (assignTagsAccounts.includes(itm.id)) {
            return {
              ...itm,
              tags: [
                ...new Set([
                  ...(itm.tags || []),
                  ...(response?.meta?.arg?.tags || []),
                ]),
              ],
            };
          }
          return itm;
        });
        setAllData(val);
        fetchData();
        setLoading(true);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error adding tags:", error);
      CommonToast({
        text: error.message || "An error occurred while adding the tags.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleRemoveTags = async (item) => {
    if (tagActionDispatchedRef) {
      tagActionDispatchedRef.current = true;
    }

    try {
      setLoading(true);

      const response = await dispatch(
        removeOwnerAccTags({
          owner_id:
            selectedAssignedAccountID !== ""
              ? [selectedAssignedAccountID]
              : [...assignTagsAccounts],
          tags: item,
        }),
      );

      if (response?.payload?.status === true) {
        let val = allData.map((itm) => {
          if (assignTagsAccounts.includes(itm.id)) {
            return {
              ...itm,
              tags: itm.tags.filter(
                (tag) => !response?.meta?.arg?.tags?.includes(tag),
              ),
            };
          }
          return itm;
        });
        setAllData(val);

        setLoading(true);
      } else {
        setLoading(false);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error removing tag:", error);
    }
  };

  useEffect(() => {
    const selectedButton = balanceSelectorRef.current?.querySelector(
      `[data-type="${selectAmtType}"]`,
    );

    if (selectedButton && indicatorRef.current && balanceSelectorRef.current) {
      const buttonRect = selectedButton.getBoundingClientRect();
      const containerRect = balanceSelectorRef.current.getBoundingClientRect();

      const offsetLeft = buttonRect.left - containerRect.left;
      const offsetWidth = buttonRect.width;

      indicatorRef.current.style.left = `${offsetLeft + 5}px`;
      indicatorRef.current.style.width = `${offsetWidth - 9}px`;
    }
  }, [selectAmtType]);

  const handleRefresh = async (id) => {
    try {
      let response = await dispatch(getOwnerAccBalance(id));
      if (response?.payload?.status == true) {
        setSuccessRefreshId([id]);
        let balance = 0;
        let data = accumulatedData.map((item) => {
          if (
            response.payload?.owner_accounts?.[0]?.owner_account_id === item?.id
          ) {
            balance =
              Number(total_balance_state) -
              Number(item?.owner_account_balance) +
              Number(
                response.payload?.owner_accounts?.[0]?.owner_account_balance,
              );
            return {
              ...item,
              owner_account_balance_last_fetched_at_in_words:
                response.payload?.owner_accounts?.[0]
                  ?.owner_account_balance_last_fetched_at_in_words,
              owner_account_balance:
                response.payload?.owner_accounts?.[0]?.owner_account_balance,
              owner_account_balance_last_fetched_at:
                response.payload?.owner_accounts?.[0]
                  ?.owner_account_balance_last_fetched_at,
              difference: Math.abs(
                Number(item?.owner_account_balance) -
                  Number(
                    response.payload?.owner_accounts?.[0]
                      ?.owner_account_balance,
                  ),
              ),
              increaseOrDecrease:
                Number(item?.owner_account_balance) >
                Number(
                  response?.payload?.owner_accounts?.[0]?.owner_account_balance,
                )
                  ? "decreased"
                  : Number(item?.owner_account_balance) <
                      Number(
                        response.payload?.owner_accounts?.[0]
                          ?.owner_account_balance,
                      )
                    ? "increased"
                    : "",
            };
          }
          return item;
        });
        setTotal_balance_state(Number(balance));
        setAccumulatedData(data);
      } else {
        setFailedRefreshId([id]);

        setTimeout(() => {
          toast.dismiss();
          CommonToast({
            text: response?.payload?.response?.data?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        }, 500);
      }
    } catch (error) {
      CommonToast({
        text: error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  };

  const filteredData = accumulatedData;
  const isEmptyDataState = !filteredData?.length || !accumulatedData?.length;
  const postiveBalanceData = accumulatedData.filter(
    (item) =>
      item.connected_banking == "Y" && Number(item.owner_account_balance) >= 0,
  );
  const negativeBalanceData = accumulatedData.filter(
    (item) =>
      item.connected_banking == "Y" && Number(item.owner_account_balance) < 0,
  );

  const handlePagination = (page) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop =
        GlobalConfiguration.lengthCheckZero;
    }
    handleSubmit("pageno", page);
    setCurrentPage(page);
    setAssignTagsAccounts([]);
    setLabelAccounts([]);
  };

  const handleViewStatement = () => {
    setViewstatementOpenPop(true);
  };

  const fetchFilterData = async () => {
    let data = [];
    setLoadingData(true);
    switch (active) {
      case "Labels":
        data = labels
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;

      case "Bank name":
        data = bankOptions
          ?.filter((itm) => {
            if (itm?.toLowerCase().includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Bank_name: val };
          });
        setInputData(data);
        setLoadingData(false);

        break;

      case "Tags":
        data = tagsOptions
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Tag: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Search":
        setSearchUserText(searchUserTextDebounce);
        setLoadingData(false);
        break;
      default:
        setLoadingData(false);
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  useEffect(() => {
    if (selectedAccount !== "All selected accounts") {
      const selectedAccountTags =
        allData?.find((account) => account.id === selectedAssignedAccountID)
          ?.tags || [];

      setNewSelectedTags(
        selectedAccountTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );

      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else if (
      selectedTagsCards?.length &&
      selectedAccount !== "All selected accounts"
    ) {
      const accountTags =
        allData?.find((account) => assignTagsAccounts.includes(account.id))
          ?.tags || [];
      setNewSelectedTags(
        accountTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else if (
      selectedTagsCards?.length ||
      selectedAccount === "All selected accounts"
    ) {
      let a = allData?.filter((account) =>
        assignTagsAccounts.includes(account.id),
      );
      const commonTags = a.reduce((common, account) => {
        return common.filter((tag) => account.tags?.includes(tag));
      }, a[0]?.tags || []);

      const uncommonTags = a.reduce((uncommon, account) => {
        return uncommon.concat(
          account.tags?.filter((tag) => !commonTags.includes(tag)) || [],
        );
      }, []);

      setNewSelectedTags(
        commonTags.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );

      setAllTags(
        [...new Set([...availableTags, ...uncommonTags])].map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    } else {
      setNewSelectedTags([]);
      setAllTags(
        availableTags?.map((tag) => ({
          value: tag,
          selected: true,
          type: "ownerTags",
        })),
      );
    }
  }, [
    assignTagsAccounts,
    selectedAssignedAccountID,
    accumulatedData,
    mainData,
    accumulatedData,
    allData,
  ]);

  const handleSelectAll = () => {
    if (!owneraccountnumberstate?.length) {
      setowneraccountnumberstate(() => {
        return filteredData?.slice(0, 10)?.map((ac) => {
          return ac.id;
        });
      });
    } else if (
      (owneraccountnumberstate?.length ==
        GlobalConfiguration.owneraccountnormalLength ||
        owneraccountnumberstate?.length === filteredData?.length) &&
      !searchUserText?.length &&
      !accountbalancestate?.length &&
      !ownerTagState?.length &&
      !labelsFilter?.length &&
      !typeaccountstate?.length &&
      !bankstate?.length &&
      !panstate?.length &&
      !accountnumberstate?.length &&
      !ifscstate?.length
    ) {
      setowneraccountnumberstate([]);
    } else if (
      (searchUserText?.length ||
        accountbalancestate?.length ||
        ownerTagState?.length ||
        labelsFilter?.length ||
        typeaccountstate?.length ||
        bankstate?.length ||
        panstate?.length ||
        accountnumberstate?.length ||
        ifscstate?.length > 0) &&
      (owneraccountnumberstate?.length ==
        GlobalConfiguration.owneraccountnormalLength ||
        owneraccountnumberstate?.length === filteredData?.length ||
        filteredData?.every((ac) => {
          return owneraccountnumberstate?.includes(ac.id);
        }))
    ) {
      let arr = [...owneraccountnumberstate];
      for (let i = 0; i < filteredData?.length; i++) {
        if (owneraccountnumberstate?.includes(filteredData[i].id)) {
          arr = arr.filter((ac) => {
            return ac != filteredData[i].id;
          });
        }
      }
      setowneraccountnumberstate(arr);
    } else {
      let arr = [...owneraccountnumberstate];
      for (let i = 0; i < 10; i++) {
        if (arr?.length < 10) {
          if (!owneraccountnumberstate?.includes(filteredData[i]?.id)) {
            if (filteredData[i]?.id) {
              arr.push(filteredData[i]?.id);
            }
          }
        }
      }
      setowneraccountnumberstate(arr);
    }
  };

  const handleSelectAllNonConsolidated = () => {
    const fd = splitView ? postiveBalanceData : filteredData;

    if (allSelected) {
      const isFilterApplied = !!(
        searchUserText?.length ||
        accountbalancestate?.length ||
        ownerTagState?.length ||
        labelsFilter?.length ||
        typeaccountstate?.length ||
        bankstate?.length ||
        panstate?.length ||
        accountnumberstate?.length ||
        ifscstate?.length
      );

      if (!isFilterApplied) {
        if (isAssignTagsClicked) setAssignTagsAccounts([]);
        if (isLabelClicked) setLabelAccounts([]);
      } else {
        if (isAssignTagsClicked) {
          setAssignTagsAccounts((prev) =>
            prev.filter((id) => !fd.some((item) => item.id === id)),
          );
        }
        if (isLabelClicked) {
          setLabelAccounts((prev) =>
            prev.filter((id) => !fd.some((item) => item.id === id)),
          );
        }
      }
    } else {
      const newIds = fd.slice(0, MAX_SELECT_LIMIT).map((d) => d.id);

      if (isAssignTagsClicked) {
        setAssignTagsAccounts((prev) => {
          const combined = Array.from(new Set([...prev, ...newIds]));
          return combined.slice(0, MAX_SELECT_LIMIT);
        });
      }

      if (isLabelClicked) {
        setLabelAccounts((prev) => {
          const combined = Array.from(new Set([...prev, ...newIds]));
          return combined.slice(0, MAX_SELECT_LIMIT);
        });
      }
    }
  };

  useEffect(() => {
    const fd = splitView ? postiveBalanceData : filteredData;

    if (assignTagsAccounts?.length > MAX_SELECT_LIMIT) {
      setAssignTagsAccounts((s) => s.slice(0, MAX_SELECT_LIMIT));
    }
    if (labelAccounts?.length > MAX_SELECT_LIMIT) {
      setLabelAccounts((s) => s.slice(0, MAX_SELECT_LIMIT));
    }

    const isFullySelected = (selectedArray) => {
      return (
        selectedArray?.length === MAX_SELECT_LIMIT ||
        selectedArray?.length === fd?.length ||
        (fd?.length > GlobalConfiguration?.lengthCheckZero &&
          fd?.every((ac) => selectedArray?.includes(ac.id)))
      );
    };

    let currentSelectionStatus = false;

    if (isAssignTagsClicked) {
      currentSelectionStatus = isFullySelected(assignTagsAccounts);
    } else if (isLabelClicked) {
      currentSelectionStatus = isFullySelected(labelAccounts);
    }

    setAllSelected(currentSelectionStatus);
  }, [
    assignTagsAccounts,
    labelAccounts,
    filteredData,
    postiveBalanceData,
    splitView,
    isAssignTagsClicked,
    isLabelClicked,
  ]);

  const handleClose = () => {
    setIsTagsPopupOpen(false);

    if (tagActionDispatchedRef.current) {
      fetchData();
      setAssignTagsAccounts([]);
      setIsAssignTagsClicked(false);
    }
  };

  const handleCloseAccount = async () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      await fetchData();
      labelActionDispatchedRef.current = false;
    }

    setLabelAccounts([]);
    setisLabelClicked(false);
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);

    const res = await dispatch(
      addNewLabelOwner({
        record_ids: toArray(labelAccounts),
        labels: labelsToAssign,
      }),
    );

    if (addNewLabelOwner.fulfilled.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addNewLabelOwner.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLoading(false);
    if (addNewLabelOwner?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      removeNewLabelOwner({
        record_ids: toArray(labelAccounts),
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabelOwner.fulfilled.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeNewLabelOwner.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLoading(false);
    if (removeNewLabelOwner?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleSubmit = (key, value) => {
    if (typepop !== "popup") {
      handleSearchParams(key, value);
    }
  };

  return (
    <>
      {isTagsPopupOpen && (
        <div
          onClick={() => {
            setIsTagsPopupOpen(false);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignTagPopup
            headerTitle="Assign/Unassign tags:"
            closehandleFunction={handleClose}
            closedisabledBgColor=""
            closebuttonRef=""
            closeimgColor=""
            loading={loading}
            newTags={newSelectedTags}
            handleAddTags={handleAddTags}
            handleRemoveTags={handleRemoveTags}
            setNewTags={setNewSelectedTags}
            AllTags={AllTags}
            setAllTags={setAllTags}
            setLoading={setLoading}
            selectedAssignedAccountID={selectedAssignedAccountID}
            selectedAccount={selectedAccount}
            setSelectedAccount={setSelectedAccount}
            setSelectedAssignedAccountID={setSelectedAssignedAccountID}
            ownerDetailData={[
              ...new Map(allData.map((item) => [item["id"], item])).values(),
            ].filter((account) => assignTagsAccounts.includes(account.id))}
            type="ownerViewAll"
          />
        </div>
      )}

      <>
        {/* Todo  */}
        {viewStatementOpenPop && (
          <div
            style={{ zIndex: "var(--max-zindex)" }}
            className="fixed top-left-base left-left-base w-width-full h-height-full bg-custom-backdrop bg-opacity-dark-opacity"
          >
            <div className="animate-none Qmd:animate-slideInFromRight w-width-full h-height-full fixed top-left-base">
              <div
                style={{ backgroundColor: "var(--primary-card)" }}
                className="common_popup relative flex flex-col"
              >
                <div className="top-left-base bg-primary-card z-z-index-header hidden Qmd:flex p-padding-md left-left-base justify-between items-center w-width-full">
                  <p className="popup-header">View account statement</p>
                  <IconRoundButton
                    enabledBgColor="var(--primary-nav)"
                    isLoading={loading}
                    handleFunction={() => {
                      setViewstatementOpenPop(false);
                    }}
                    hoverOption="white"
                    icon={
                      "https://q2pay.in/new_assets/common/create_flow/close.svg"
                    }
                    title="Close"
                    isDisabled={false}
                  />
                </div>
                <OwnerAllStatement
                  setViewstatementOpenPop={setViewstatementOpenPop}
                  popType={"ownerStatement"}
                  ownerDetailId={statementId}
                  ownerDetailData={accData}
                />
              </div>
            </div>
          </div>
        )}
        {
          // {/* Todo  */}
        }

        {isLabelPopupOpen && (
          <div className="fixed top-top-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
            <CommonAssignLabelPopup
              headerTitle="Assign/Unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleCloseAccount}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={labelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={[
                ...new Map(
                  accumulatedData.map((item) => [item["id"], item]),
                ).values(),
              ].filter((account) => labelAccounts.includes(account.id))}
              onClose={handleCloseAccount}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              type="viewall"
            />
          </div>
        )}

        {refreshAll && (
          <div
            className={
              refreshAll
                ? "refresh-transition-open"
                : "refresh-transition-close"
            }
            style={{
              paddingTop: typepop === "popup" ? "" : "var(--padding-xl)",
              marginTop:
                typepop === "popup" ? "var(--padding-md)" : "var(--padding-md)",
            }}
          >
            {/* Todo  */}
            <RefreshAllLoader
              setRefreshAll={setRefreshAll}
              data={connectedBankingData}
              setAccumulatedData={setAccumulatedData}
              mainData={filteredData}
              total_balance_state={total_balance_state}
              setTotal_balance_state={setTotal_balance_state}
              setFailedRefreshId={setFailedRefreshId}
              setSuccessRefreshId={setSuccessRefreshId}
            />
          </div>
        )}

        <div
          className={`bg-primary-bg flex flex-col ${typepop === "popup" ? "h-full" : "h-screen"}  overflow-hidden relative z-z-index-header`}
        >
          <div>
            <div
              className={`bg-primary-nav h-navbar-breadcrumb-height z-z-index-header ${
                typepop === "popup" ? "hidden" : "Qsmd:flex hidden"
              }`}
            ></div>

            <div
              className={`absolute bg-primary-nav bottom-bottom-base w-full rounded-none
                ${
                  showInnerSearchBar
                    ? "z-z-index-dropdown pointer-events-none"
                    : "z-z-index-dropdown"
                }
                ${showInnerSearchBar && "pointer-events-none"}`}
            >
              {accumulatedData?.length > GlobalConfiguration?.lengthCheckZero &&
                filteredData?.length > GlobalConfiguration?.lengthCheckZero && (
                  <div className={`${showInnerSearchBar && "h-height-full"}`}>
                    {showInnerSearchBar && (
                      <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity pointer-events-none w-full h-full z-z-index-header" />
                    )}
                    <PaginationComponent
                      handleSelect={handleSelect}
                      selectedValue={selectedValue}
                      data={mainData}
                      pageSize={pageSize}
                      dropdownOptions={dropdownOptions}
                      handlePagination={handlePagination}
                      currentPage={currentPage}
                      setIsOpen={setIsOpen}
                      typePopup={typepop === "popup"}
                    />
                  </div>
                )}
            </div>
            <TopNavComponentWithBalance
              loading={loading}
              ispagination={
                accumulatedData?.length > GlobalConfiguration?.lengthCheckOne ||
                filteredData?.length > GlobalConfiguration?.lengthCheckOne
                  ? true
                  : false
              }
              topNavCtaBtn1Needed={false}
              topNavCtaBtn1Props={
                isAssignTagsClicked || isLabelClicked || multiSelect
                  ? {
                      btnText:
                        assignTagsAccounts?.length ||
                        labelAccounts?.length ||
                        multiSelect
                          ? "Clear"
                          : "Cancel",
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: (e) => {
                        if (multiSelect) {
                          setowneraccountnumberstate([]);
                        } else {
                          const textContent = e.target.textContent.trim();
                          setAllSelected(false);
                          if (textContent === "Clear") {
                            setAssignTagsAccounts([]);
                            setLabelAccounts([]);
                            return;
                          } else if (textContent === "Cancel") {
                            setIsAssignTagsClicked(false);
                            setisLabelClicked(false);

                            if (typepop === "popup" && flow !== "internalTxn") {
                              setConnectedbankingstate("Active");
                            } else {
                              setConnectedbankingstate("");
                            }
                            handleScrollToTop();
                            setCurrentPage(GlobalConfiguration.lengthCheckOne);
                          }
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: multiSelect
                        ? owneraccountnumberstate.length ===
                            GlobalConfiguration.lengthCheckZero ||
                          showInnerSearchBar
                        : showInnerSearchBar,
                      hoverOption: "black",
                    }
                  : null
              }
              topNavCtaBtn2Needed={false}
              topNavCtaBtn2Props={
                isAssignTagsClicked || isLabelClicked || multiSelect
                  ? {
                      btnText: isAssignTagsClicked
                        ? "Assign tags"
                        : multiSelect
                          ? "Confirm"
                          : "Assign labels",
                      btnType: "button",
                      enabledBgColor:
                        multiSelect && !owneraccountnumberstate?.length
                          ? "var(--text-disabled)"
                          : assignTagsAccounts?.length ||
                              labelAccounts?.length ||
                              owneraccountnumberstate?.length
                            ? "var(--text-primary)"
                            : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (multiSelect) {
                          if (owneraccountnumberstate?.length) {
                            if (
                              !owneraccountNumber?.length &&
                              !owneraccountDefaultNumber?.length
                            ) {
                              setDefaultAccountNumber(owneraccountnumberstate);
                              setownerAccountNumber(owneraccountnumberstate);
                              setowneraccountnumberstate(
                                owneraccountnumberstate,
                              );
                            }
                            onClosed(false);
                          }
                        } else {
                          if (assignTagsAccounts?.length) {
                            setIsTagsPopupOpen(true);
                          } else if (labelAccounts?.length) {
                            setIsLabelPopupOpen(true);
                          }
                        }
                      },
                      enabledTextColor:
                        multiSelect && !owneraccountnumberstate?.length
                          ? "var(--text-primary)"
                          : assignTagsAccounts?.length ||
                              assignTagsAccounts?.length ||
                              labelAccounts?.length ||
                              owneraccountnumberstate?.length
                            ? "var(--primary-bg)"
                            : "var(--text-primary)",
                      hoverOption: "black",
                      inActiveVariantNeeded: true,

                      isDisabled:
                        multiSelect && !owneraccountnumberstate?.length
                          ? true
                          : assignTagsAccounts?.length ||
                              labelAccounts?.length ||
                              owneraccountnumberstate?.length
                            ? false
                            : true,
                    }
                  : null
              }
              topNavHeader={total_balance_state}
              topNavSubText={"Total balance"}
              BalanceStateRequired={
                isAssignTagsClicked || isLabelClicked || multiSelect
                  ? false
                  : true
              }
              BottomSubTextVaraint={"primary"}
              BottomSubText={
                multiSelect
                  ? undefined
                  : isAssignTagsClicked
                    ? "Select accounts to apply tags. Tagged users will gain access to view only owner accounts that share the same tags."
                    : isLabelClicked
                      ? "Select accounts to apply labels. These labels will be used to generate statistics for the associated accounts."
                      : undefined
              }
              isSelectionView={
                isAssignTagsClicked || isLabelClicked || multiSelect
              }
              isToggleNeeded={false}
              toggleProps={
                !multiSelect && !isLabelClicked && !isAssignTagsClicked
                  ? {
                      state: toggle,
                      title: !toggle ? " List view" : "Grid view",
                      isDisabled: showInnerSearchBar,
                      handleClick: (e) => {
                        e.stopPropagation();
                        if (scrollContainerRef.current) {
                          scrollContainerRef.current.scrollTop =
                            GlobalConfiguration.lengthCheckZero;
                        }
                        setFailedRefreshId([]);
                        setSuccessRefreshId([]);

                        if (toggle) {
                          dispatch(setToggle(false));
                        } else {
                          dispatch(setToggle(true));
                        }
                      },
                    }
                  : undefined
              }
              selectionText={
                isAssignTagsClicked || isLabelClicked || multiSelect
                  ? `Accounts selected: ${
                      multiSelect
                        ? owneraccountnumberstate?.length || "0"
                        : isAssignTagsClicked || isLabelClicked
                          ? assignTagsAccounts?.length ||
                            labelAccounts?.length ||
                            "0"
                          : undefined
                    }`
                  : ""
              }
              selectionBtnProps={
                ((isAssignTagsClicked || isLabelClicked) &&
                  filteredData.length) ||
                postiveBalanceData.length ||
                negativeBalanceData.length
                  ? {
                      btnText: multiSelect ? "Select up to 10" : "Select all",
                      btnType: "button",
                      handleFunction: () => {
                        setAllSelected((s) => !s);
                        if (multiSelect && filteredData?.length) {
                          handleSelectAll();
                        } else if (isAssignTagsClicked || isLabelClicked) {
                          handleSelectAllNonConsolidated();
                        }
                      },
                      enabledBgColor: multiSelect
                        ? owneraccountnumberstate?.length ==
                            GlobalConfiguration.owneraccountnormalLength ||
                          owneraccountnumberstate?.length ===
                            filteredData?.length ||
                          filteredData?.every((ac) => {
                            return owneraccountnumberstate?.includes(ac.id);
                          })
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)"
                        : (
                              splitView
                                ? postiveBalanceData.length ===
                                    GlobalConfiguration?.lengthCheckZero &&
                                  negativeBalanceData.length ===
                                    GlobalConfiguration?.lengthCheckZero
                                : filteredData.length ===
                                  GlobalConfiguration?.lengthCheckZero
                            )
                          ? "var(--primary-nav-act)"
                          : allSelected
                            ? "var(--positive-bg)"
                            : "var(--primary-nav-act)",

                      hoverOption: multiSelect
                        ? owneraccountnumberstate?.length ==
                            GlobalConfiguration.owneraccountnormalLength ||
                          owneraccountnumberstate?.length ===
                            filteredData?.length ||
                          filteredData?.every((ac) => {
                            return owneraccountnumberstate?.includes(ac.id);
                          })
                          ? "black"
                          : "white"
                        : allSelected
                          ? "black"
                          : "white",
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: splitView
                        ? postiveBalanceData.length ===
                            GlobalConfiguration?.lengthCheckZero &&
                          negativeBalanceData.length ===
                            GlobalConfiguration?.lengthCheckZero
                        : filteredData.length ===
                          GlobalConfiguration?.lengthCheckZero,
                      icon:
                        allSelected &&
                        (splitView
                          ? postiveBalanceData.length >
                              GlobalConfiguration?.lengthCheckZero ||
                            negativeBalanceData.length >
                              GlobalConfiguration?.lengthCheckZero
                          : filteredData.length >
                            GlobalConfiguration?.lengthCheckZero)
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg",
                    }
                  : undefined
              }
              iconComponentArray={
                !multiSelect
                  ? [
                      {
                        enabledBgColor: "var(--primary-bg)",
                        isLoading: loading,
                        handleFunction: (e) => {
                          if (!showInnerSearchBar) {
                            e.stopPropagation();
                            if (
                              services?.includes("VAccountBalance") ||
                              services?.includes("Admin")
                            ) {
                              setTimeout(() => {
                                let selectedData = accumulatedData?.map(
                                  (item) => {
                                    return {
                                      id: item.id,
                                      prevbalance: item?.owner_account_balance,
                                    };
                                  },
                                );
                                setFailedRefreshId([]);
                                setSuccessRefreshId([]);
                                setRefreshtype("all");
                                setPrev_Total_balance_state(
                                  total_balance_state,
                                );
                                setID(true);
                                setRefreshAllData(selectedData);
                                setRefreshAll(true);
                              }, 500);
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "VAccountBalance,Admin",
                                },
                              });
                            }
                          }
                        },
                        isDisabled:
                          showInnerSearchBar &&
                          (services?.includes("VAccountBalance") ||
                            services?.includes("Admin")),
                        icon: "https://q2pay.in/new_assets/common/view_all/reload_refresh_white.svg",
                        title: "Refresh all balances",
                        hoverOption: "white",
                      },
                    ]
                  : undefined
              }
              AllPageRefresh={failedRefreshId.length > 0}
              failedRefreshId={failedRefreshId}
              selectAmtType={selectAmtType}
              prevBalance={prev_total_balance_state}
              TotalBalance={total_balance_state}
              ownerAccBalanceLoading={ownerAccBalanceLoading}
              assignLabelNeeded={true}
              assignTagNeeded={true}
              assignLabelProps={
                !isLabelClicked && !multiSelect
                  ? {
                      handleFunction: () => {
                        if (
                          showInnerSearchBar ||
                          (!services?.includes("ALabel") &&
                            !services?.includes("RLabel")) ||
                          isAssignTagsClicked
                        )
                          return;
                        if (typepop === "popup") {
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                          });
                        } else if (
                          services?.includes("ALabel") &&
                          services?.includes("RLabel")
                        ) {
                          setisLabelClicked((prev) => {
                            if (prev) {
                              setLabelAccounts([]);
                            }
                            return !prev;
                          });
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "ALabel,RLabel",
                            },
                          });
                        }
                      },
                      isDisabled:
                        showInnerSearchBar ||
                        (!services?.includes("ALabel") &&
                          !services?.includes("RLabel")) ||
                        isAssignTagsClicked ||
                        typepop === "popup",
                      enabledBgColor: "var(--primary-bg)",
                      isLoading: false,
                      hoverOption: "white",
                      buttonRef: null,
                      title:
                        "Labels will be used to generate statistics for the associated accounts",
                    }
                  : undefined
              }
              assignTagProps={
                !isAssignTagsClicked && !multiSelect
                  ? {
                      handleFunction: () => {
                        if (
                          isLabelClicked ||
                          (!services?.includes("COwnerTag") &&
                            !services?.includes("DOwnerTag")) ||
                          showInnerSearchBar
                        )
                          return;

                        if (typepop === "popup") {
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                          });
                          return;
                        }

                        if (
                          !services?.includes("COwnerTag") &&
                          !services?.includes("DOwnerTag")
                        ) {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: !services?.includes(
                                "COwnerTag",
                              )
                                ? "COwnerTag"
                                : "DOwnerTag",
                            },
                          });
                        }

                        handleScrollToTop();
                        setIsAssignTagsClicked(true);

                        if (typepop === "popup" && flow !== "internalTxn") {
                          setConnectedbankingstate("Active");
                        } else {
                          setConnectedbankingstate("");
                        }
                      },
                      isDisabled:
                        (!services?.includes("COwnerTag") &&
                          !services?.includes("DOwnerTag")) ||
                        isLabelClicked ||
                        showInnerSearchBar ||
                        typepop === "popup",
                      enabledBgColor: "var(--primary-bg)",
                      isLoading: false,

                      hoverOption: "white",
                      buttonRef: null,
                      title:
                        "Tags will be used to give access of owner accounts to the users who share even one of the assigned tags.",
                    }
                  : undefined
              }
              filteredSearchProps={{
                setShowInnerSearchBar: setShowInnerSearchBar,
                showInnerSearchBar: showInnerSearchBar,
                isSearchDisabled: loading,
                onSearchInput: (val) => {
                  setsearchUserTextDebounce(val);
                },

                searchText: searchUserTextDebounce,
                searchPlaceholder: "Search owner account",
                filterPlaceholder: "owner account ID/ name/ email ID",
                filterItems: [
                  {
                    name: "Search",
                    isMulti: false,
                    value: searchUserText,
                    setValue: (val) => {
                      setSearchUserText(val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("search", val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },

                  {
                    name: "Account number",
                    short_name: "Acc .no",
                    isMulti: false,
                    value: accountnumberstate,
                    setValue: (val) => {
                      handleSubmit("accno", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setaccountnumberstate(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "IFSC code",
                    short_name: "IFSC",
                    isMulti: false,
                    value: ifscstate,
                    setValue: (val) => {
                      handleSubmit("ifsc", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setifscstate(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "Bank name",
                    isMulti: false,
                    value: bankstate,
                    setValue: (val) => {
                      handleSubmit("bank", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setbankstate(val);
                    },
                    isDropdown: true,
                    isDisabled: loading,
                    isAlphabetical: true,
                  },
                  {
                    name: "PAN number",
                    short_name: "Pan",
                    isMulti: false,
                    value: panstate,
                    setValue: (val) => {
                      handleSubmit("pan", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setpanstate(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: labelsFilter,
                    setValue: (val) => {
                      handleSubmit("label", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setFilterLabels(val);
                    },
                    isDropdown: true,
                    isDisabled: loading,
                  },
                  {
                    name: "Tags",
                    short_name: "Tag",
                    isMulti: true,
                    value: ownerTagState,
                    setValue: (val) => {
                      handleSubmit("tag", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setOwnerTagState(val);
                    },
                    isDropdown: true,
                    isDisabled: loading,
                  },
                ],
                filters: [
                  {
                    name: "Type of account",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: [
                      "Current account",
                      "Overdraft account",
                      "Cash credit account",
                      "Fixed deposit account",
                    ],

                    dropdownPlaceHolder: "Select type",
                    value: typeaccountstate,
                    isDisable: false,
                    handleChange: (val) => {
                      handleSubmit("acctype", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      settypeaccountstate(val);
                    },
                  },

                  {
                    name: "Connected banking",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["Active", "Inactive"],
                    isDisabled:
                      typepop === "popup" && flow !== "internalTxn"
                        ? true
                        : false,
                    dropdownPlaceHolder: "Select status",
                    value: connectedbankingstate,
                    handleChange: (val) => {
                      handleSubmit("connectbank", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setConnectedbankingstate(val);
                    },
                  },

                  {
                    name: "Favourite",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["Show only favourite", "Hide favourite"],
                    isDisabled: false,
                    dropdownPlaceHolder: "Default (all accounts)",
                    value: favouritesFilter,
                    handleChange: (val) => {
                      handleSubmit("favourite", val);

                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setFavouritesFilter(val);
                    },
                  },
                ],
                sortByFilter: [
                  {
                    name: "Newest",
                    default: true,
                    isDisabled: false,
                  },
                  {
                    name: "High to low",
                    isDisabled: false,
                  },
                  {
                    name: "Low to high",
                    isDisabled: false,
                  },
                ],
                sortValue: accountbalancestate,
                sortHandleChange: (val) => {
                  handleSubmit("sort", val);

                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setaccountbalancestate(val);
                },
                isFilterClearAllDisabled: !(
                  (connectedbankingstate?.length && typepop !== "popup") ||
                  typeaccountstate?.length ||
                  favouritesFilter?.length ||
                  bankstate?.length ||
                  loading
                ),

                isSearchClearAllDisabled: !(
                  accountnumberstate?.length ||
                  panstate?.length ||
                  searchUserText?.length ||
                  labelsFilter?.length ||
                  ownerTagState?.length ||
                  ifscstate?.length ||
                  loading
                ),

                inputData: inputData,
                active: active,
                setActive: setActive,
                loading: loading,
                setLoading: setLoadingData,
                isShowSortBy: true,
                isShowFilter: true,
                loadingData: loadingData,
              }}
            />
            {/* ------------------------ */}
          </div>

          <div
            className={
              showInnerSearchBar
                ? `h-screen ownerviewallscroll flex flex-col opacity-dark-opacity bg-PopUp-BackDrop pointer-events-none w-full z-z-index-content Qsmd:z-z-index-header ${isEmptyDataState ? "overflow-y-hidden pb-padding-xl mt-margin-xs" : ""}`
                : isEmptyDataState
                  ? "overflow-y-hidden h-screen Qsmd:pb-padding-xl pb-padding-base ownerviewallscroll mt-margin-xs mb-margin-base Qsmd:mb-margin-lg"
                  : `flex-1 ${isLabelClicked || isAssignTagsClicked || multiSelect ? "mb-[var(--topnav-bottom-height)] Qsmd:mb-[var(--pagination-height)]" : "mb-[var(--pagination-height)]"} overflow-y-auto relative z-z-index-content`
            }
            style={{
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: "var(--padding-md)",
            }}
            ref={setScrollableContainerRef}
          >
            <div
              className={`${showInnerSearchBar || loading || !filteredData?.length || !accumulatedData?.length ? "overflow-hidden" : ""} h-full flex flex-col`}
            >
              <div
                className={`${showInnerSearchBar && "opacity-light-opacity bg-PopUp-BackDrop z-z-index-base pointer-events-none relative"} mx-auto w-width-full max-w-tab-width-normal my-margin-base mt-margin-md px-padding-sm Qlg:p-padding-base`}
              >
                <SwitcherTabsWithSplitView
                  initialActiveTab="Default"
                  tabs={[
                    {
                      label: "Default",
                      key: "Default",
                      handler: () => setSelectAmtType("Default"),
                    },
                    {
                      label: "Lakhs (L)",
                      key: "Lakhs",
                      handler: () => setSelectAmtType("Lakhs"),
                    },
                    {
                      label: "Crores (Cr)",
                      key: "Crores",
                      handler: () => setSelectAmtType("Crores"),
                    },
                    {
                      label: "Millions (M)",
                      key: "Millions",
                      handler: () => setSelectAmtType("Millions"),
                    },
                    {
                      label: "Billions (B)",
                      key: "Billions",
                      handler: () => setSelectAmtType("Billions"),
                    },
                  ]}
                  isDisabled={showInnerSearchBar}
                  swicherTabBgColor={"var(--primary-card)"}
                  handleClick={(e) => {
                    e.stopPropagation();
                    splitView == ""
                      ? setSplitView(true)
                      : setSplitView(!splitView);
                  }}
                  state={splitView}
                  splitViewtype={"splitView"}
                />
              </div>

              <div
                className={`${
                  showInnerSearchBar ? "overflow-y-hidden" : ""
                } flex-1 ${
                  accumulatedData?.length == GlobalConfiguration.lengthCheckZero
                    ? "mb-bottom-base mt-margin-lg"
                    : isLabelClicked || isAssignTagsClicked || multiSelect
                      ? "Qsmd:mb-[var(--pagination-height)] mb-topnav-bottom-height"
                      : ""
                }`}
                style={{
                  height:
                    (!filteredData?.length || !accumulatedData?.length) &&
                    "var(--height-full)",
                }}
              >
                {loading ? (
                  <div className="flex flex-col items-center justify-center h-height-full ">
                    <Loader />
                  </div>
                ) : filteredData?.length ||
                  accumulatedData?.length ||
                  splitView ? (
                  <div
                    className={`flex flex-col min-h-height-base h-full items-center ${showInnerSearchBar && "pointer-events-none"} w-full   ${
                      showInnerSearchBar &&
                      "overflow-y-hidden opacity-light-opacity"
                    }`}
                  >
                    {!toggle ? (
                      <OwnerViewAllCard
                        filterRef={filterRef}
                        typepop={typepop}
                        handleButtonClick={handleButtonClick}
                        setIsNeft={setIsNeft}
                        setIsImps={setIsImps}
                        flow={flow}
                        setIsRtgs={setIsRtgs}
                        txnPayLoad={txnPayLoad}
                        setTxnPayLoad={setTxnPayLoad}
                        setpaymentBox={setpaymentBox}
                        BenEnableNextButton={BenEnableNextButton}
                        setOpenOwner={setOpenOwner}
                        isopen={showInnerSearchBar}
                        setFailedRefreshId={setFailedRefreshId}
                        failedRefreshId={failedRefreshId}
                        successRefreshId={successRefreshId}
                        setSuccessRefreshId={setSuccessRefreshId}
                        handleRefresh={handleRefresh}
                        data={filteredData}
                        page={currentPage}
                        refreshAllData={refreshAllData}
                        refreshType={refreshType}
                        setRefreshtype={setRefreshtype}
                        setId={setID}
                        setPrev_Total_balance_state={
                          setPrev_Total_balance_state
                        }
                        total_balance={total_balance_state}
                        currency={selectAmtType}
                        splitView={splitView}
                        postiveBalanceData={postiveBalanceData}
                        negativeBalanceData={negativeBalanceData}
                        refreshAll={refreshAll}
                        handleViewStatement={handleViewStatement}
                        setStatementId={setStatementId}
                        accData={accData}
                        setAccData={setAccData}
                        multiSelect={multiSelect}
                        isAssignTagsClicked={isAssignTagsClicked}
                        isLabelClicked={isLabelClicked}
                        owneraccountnumberstate={
                          isAssignTagsClicked
                            ? assignTagsAccounts
                            : isLabelClicked
                              ? labelAccounts
                              : owneraccountnumberstate
                        }
                        setowneraccountnumberstate={
                          isAssignTagsClicked
                            ? setAssignTagsAccounts
                            : isLabelClicked
                              ? setLabelAccounts
                              : setowneraccountnumberstate
                        }
                        popType={popType}
                        favouritesFilter={favouritesFilter}
                        setRefactorAccDetail={setRefactorAccDetail}
                        type={type}
                        selectedLabelsCreate={selectedLabelsCreate}
                        TypeRTGS={TypeRTGS}
                        currentAccountDetails={currentAccountDetails}
                      />
                    ) : (
                      <ListView
                        filterRef={filterRef}
                        typepop={typepop}
                        handleButtonClick={handleButtonClick}
                        setIsNeft={setIsNeft}
                        setIsImps={setIsImps}
                        setIsRtgs={setIsRtgs}
                        flow={flow}
                        txnPayLoad={txnPayLoad}
                        setTxnPayLoad={setTxnPayLoad}
                        setpaymentBox={setpaymentBox}
                        BenEnableNextButton={BenEnableNextButton}
                        setOpenOwner={setOpenOwner}
                        handleRefresh={handleRefresh}
                        data={filteredData}
                        isopen={showInnerSearchBar}
                        page={currentPage}
                        refreshAllData={refreshAllData}
                        refreshType={refreshType}
                        setRefreshtype={setRefreshtype}
                        setFailedRefreshId={setFailedRefreshId}
                        failedRefreshId={failedRefreshId}
                        successRefreshId={successRefreshId}
                        setSuccessRefreshId={setSuccessRefreshId}
                        setId={setID}
                        setPrev_Total_balance_state={
                          setPrev_Total_balance_state
                        }
                        total_balance={total_balance_state}
                        currency={selectAmtType}
                        splitView={splitView}
                        postiveBalanceData={postiveBalanceData}
                        negativeBalanceData={negativeBalanceData}
                        refreshAll={refreshAll}
                        handleViewStatement={handleViewStatement}
                        setStatementId={setStatementId}
                        accData={accData}
                        setAccData={setAccData}
                        favouritesFilter={favouritesFilter}
                        multiSelect={multiSelect}
                        isAssignTagsClicked={isAssignTagsClicked}
                        isLabelClicked={isLabelClicked}
                        owneraccountnumberstate={
                          isAssignTagsClicked
                            ? assignTagsAccounts
                            : isLabelClicked
                              ? labelAccounts
                              : owneraccountnumberstate
                        }
                        setowneraccountnumberstate={
                          isAssignTagsClicked
                            ? setAssignTagsAccounts
                            : isLabelClicked
                              ? setLabelAccounts
                              : setowneraccountnumberstate
                        }
                        popType={popType}
                        setRefactorAccDetail={setRefactorAccDetail}
                        type={type}
                        selectedLabelsCreate={selectedLabelsCreate}
                        TypeRTGS={TypeRTGS}
                        currentAccountDetails={currentAccountDetails}
                      />
                    )}
                  </div>
                ) : (
                  <>
                    {showInnerSearchBar && (
                      <div className="absolute bg-PopUp-BackDrop h-full opacity-dark-opacity pointer-events-none w-full z-z-index-header"></div>
                    )}
                    <div
                      className={`flex flex-col items-center justify-center Qmd:m-auto mx-auto Qsmd:my-margin-xl my-margin-base  h-height-full gap-gap-sm ${
                        !showInnerSearchBar && multiSelect ? "h-auto" : ""
                      }`}
                    >
                      <img
                        src={
                          "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                        }
                        alt="No accounts found"
                        className={
                          "w-graphic-width-md h-graphic-rectangle-height-md"
                        }
                      />
                      <p
                        className={
                          "text-font-sm text-text-primary items-center"
                        }
                      >
                        No data found.
                      </p>
                      <div
                        style={{
                          display:
                            favouritesFilter ||
                            searchUserText?.length ||
                            connectedbankingstate?.length ||
                            accountbalancestate?.length ||
                            ownerTagState?.length ||
                            labelsFilter?.length ||
                            typeaccountstate?.length ||
                            bankstate?.length ||
                            panstate?.length ||
                            accountnumberstate?.length ||
                            ifscstate?.length
                              ? "flex"
                              : "none",
                        }}
                      >
                        <PrimaryButton
                          isDisabled={false}
                          enabledBgColor="var(--primary-act)"
                          btnText="Clear parameters"
                          enabledTextColor="var(--text-primary)"
                          handleFunction={(e) => {
                            e.stopPropagation();
                            handleClearSearchParam();
                            if (typepop === "popup") {
                              setConnectedbankingstate("Active");
                            } else {
                              setConnectedbankingstate("");
                            }
                            setFavouritesFilter(false);
                            setSearchUserText("");
                            setsearchUserTextDebounce("");
                            setbankstate("");
                            settypeaccountstate("");
                            setaccountbalancestate("");
                            setaccountnumberstate("");
                            setifscstate("");
                            setpanstate("");
                            setOwnerTagState([]);
                            setFilterLabels([]);

                            setCurrentPage(GlobalConfiguration.lengthCheckOne);
                          }}
                          buttonRef={null}
                          hoverOption="white"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default OwnerAccViewAll;
